import { getInfo } from '@/request/user'

const state = {
  token: '',
  userAccount: '',
  memberName: '',
  mobile: '',
  data: '',
  defaultCard: '',
  cardNoList: [],
  province: '',
  userType: '0'
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
  },
  SET_USER(state, { userAccount, memberName, mobile, defaultCard, cardNoList, memberNo, userType }) {
    state.userAccount = userAccount
    state.memberName = memberName
    state.mobile = mobile
    state.defaultCard = defaultCard
    state.cardNoList = cardNoList
    state.memberNo = memberNo
    state.userType = userType
  },
  SET_DATA(state, data) {
    state.data = data
  },
  SET_PROVINCE(state, province) {
    state.province = province
  }
}

const actions = {
  setData({ commit }, data) {
    commit('SET_DATA', data)
  },
  setToken({ commit }, token) {
    commit('SET_TOKEN', token)
  },
  setProvince({ commit }, province) {
    commit('SET_PROVINCE', province)
  },
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      const type = sessionStorage.getItem('reset')
      getInfo(type)
        .then(response => {
          const { userAccount, memberName, userPhone, defaultCardNo, cardNoList, memberNo, userType } = response.data
          commit('SET_USER', {
            userAccount,
            memberName,
            mobile: userPhone,
            defaultCard: defaultCardNo,
            cardNoList,
            memberNo,
            userType
          })
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
